import { router } from 'expo-router';
import { StyleSheet } from 'react-native';

import BrandedButton from '@/components/buttons/BrandedButton';
import { i18n } from '@/utils/i18n';

interface SaveAndContinueLaterButtonProps {
  disabled?: boolean;
  onPress?: () => void;
}

const SaveAndContinueLaterButton = ({ disabled = false, onPress }: SaveAndContinueLaterButtonProps) => {
  return (
    <BrandedButton
      disabled={disabled}
      backGroundColor="white"
      disabledBackGroundColor="white"
      textStyles={styles.textStyle}
      fontWeight="450"
      onPress={
        onPress !== undefined
          ? onPress
          : () => {
              if (router.canDismiss()) router.dismissAll();
              router.replace({
                pathname: '/profile/npoProfile/insights'
              });
            }
      }>
      {i18n.t('sign_in.nonProfit.save_continue')}
    </BrandedButton>
  );
};

const styles = StyleSheet.create({
  textStyle: {
    color: 'black',
    fontSize: 14
  }
});

export default SaveAndContinueLaterButton;
